import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// eslint-disable-next-line no-unused-vars
import React from 'react';
import SocialSharing from '../trustyle-social-sharing';
import { canonicalHref } from '../../helpers/meta-tags';
import { contentId, pageTitle } from '@uswitch/ev-utils/contentful';
import { Container } from '@uswitch/ev-core/react';
import { useDataSelector, useEntity, useMeta } from '@uswitch/ev-utils/context/selectors';
import { ConditionalWrapper } from '@uswitch/ev-utils/conditional-wrapper';
import { jsx as _jsx } from "theme-ui/jsx-runtime";

var SocialSharingCompound = function SocialSharingCompound(_ref) {
  var urlModule = _ref.urlModule,
      includes = _ref.includes,
      _ref$wrap = _ref.wrap,
      wrap = _ref$wrap === void 0 ? true : _ref$wrap;
  var address = canonicalHref(urlModule);
  var linkedPageId = contentId(urlModule.link);
  var linkedPage = useEntity(linkedPageId);
  var titleContent = pageTitle(linkedPage);
  var twitterAccount = useMeta('twitterAccount');
  var twitterMsg = twitterAccount ? "".concat(address, " via ").concat(twitterAccount) : '';
  return _jsx(ConditionalWrapper, {
    condition: wrap,
    wrapper: Container,
    sx: {
      variant: 'compounds.social-sharing.outer-container'
    },
    children: _jsx(SocialSharing, {
      shareUrl: address,
      twitterMessage: twitterMsg,
      mailSubject: titleContent
    })
  });
};

var SocialSharingConnected = function SocialSharingConnected(props) {
  var data = useDataSelector();
  var connectedProps = {
    urlModule: _objectSpread(_objectSpread({}, data.url), data.rootEntity.fields),
    includes: data.includes
  };
  return _jsx(SocialSharingCompound, _objectSpread(_objectSpread({}, props), connectedProps));
};

export default SocialSharingConnected;
//# sourceMappingURL=index.js.map